export { Cprepage } from './Cprepage';
export type { CprepageProps } from './Cprepage';

